import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@mezzoforte/forge';
import { formatCurrency } from '@/util/currency';

interface SafelimitModalProps {
  bidValue: number;
  safeLimit: number | null;
  onClose: () => void;
  isOpen?: boolean;
}

export function SafelimitModal({ bidValue, safeLimit, onClose, isOpen = false }: SafelimitModalProps) {
  return (
    <Modal
      headerDivider
      isOpen={isOpen}
      onDismiss={onClose}
    >
      <ModalHeader>Tarjousta ei hyväksytä</ModalHeader>
      <ModalBody>
        <Text mb={3}>
          Tarjouksesi on liian iso. Olet tarjonnut {formatCurrency(bidValue)}. Suurin mahdollinen tarjous tällä hetkellä
          on {formatCurrency(Math.floor(safeLimit ?? 0))}.
        </Text>
        <Text mb={3}>Tarjousta ei hyväksytä. Ole hyvä ja tarjoa uudestaan pienempi summa.</Text>
        <Text
          variant="bold"
          mb={3}
        >
          Huomaathan, että huutokauppaan osallistuminen ilman ostoaikomusta on kiellettyä.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>Peru tarjous</Button>
      </ModalFooter>
    </Modal>
  );
}
